<template>
  <div
    style="
      overflow: hidden;
      height: 100%;
      background-color: #f6f6f6;
      padding: 10px 0;
      display: flex;
      flex-direction: column;
    "
  >
    <van-tabs v-model:active="state.active">
      <van-tab title="填写档案信息" :name="1"></van-tab>
      <van-tab title="上传档案附件" :name="2"></van-tab>
    </van-tabs>
    <div style="overflow-y: auto; flex: 1; margin-top: 10px; padding: 0 10px">
      <van-cell-group v-if="state.active == 1">
        <van-cell
          title="姓名"
          :value="state.model.name"
          title-class="self-title"
        />
        <van-cell
          title="证件类型"
          :value="state.model.idtype"
          title-class="self-title"
        />
        <van-cell
          title="证件号"
          :value="state.model.idcard"
          title-class="self-title"
        />
        <van-cell
          title="证件生效日"
          is-link
          :value="state.model.id_start"
          @click="state.show_id_start = true"
          title-class="self-title"
        />
        <van-calendar
          v-model:show="state.show_id_start"
          switch-mode="year-month-date"
          @confirm="
            (value) => {
              state.model.id_start = $dayjs(value).format('YYYY-MM-DD');
              state.show_id_start = false;
            }
          "
        />
        <van-cell
          title="证件到期日"
          is-link
          :value="state.model.id_end"
          @click="state.show_id_end = true"
          title-class="self-title"
        />
        <van-calendar
          v-model:show="state.show_id_end"
          switch-mode="year-month-date"
          @confirm="
            (value) => {
              state.model.id_end = $dayjs(value).format('YYYY-MM-DD');
              state.show_id_end = false;
            }
          "
        />
        <van-cell
          title="性别"
          is-link
          title-class="self-title"
          :value="state.model.sex"
          @click="state.show_sex = true"
        />
        <van-popup
          v-model:show="state.show_sex"
          destroy-on-close
          round
          position="bottom"
        >
          <van-picker
            title="性别"
            :columns="[
              { text: '男', value: '男' },
              { text: '女', value: '女' },
            ]"
            @confirm="
              (item) => {
                state.model.sex = item.selectedValues[0];
                state.show_sex = false;
              }
            "
            @cancel="
              () => {
                state.show_sex = false;
              }
            "
          />
        </van-popup>
        <van-cell
          title="民族"
          title-class="self-title"
          is-link
          :value="state.model.nation"
          @click="state.show_nation = true"
        />
        <van-popup
          v-model:show="state.show_nation"
          destroy-on-close
          round
          position="bottom"
        >
          <van-picker
            title="民族"
            :columns="state.peoples"
            @confirm="
              (item) => {
                state.model.nation = item.selectedValues[0];
                state.show_nation = false;
              }
            "
            @cancel="
              () => {
                state.show_nation = false;
              }
            "
          />
        </van-popup>
        <van-cell
          title="婚姻状况"
          title-class="self-title"
          is-link
          :value="state.model.marital_status"
          @click="state.show_marital_status = true"
        />
        <van-popup
          v-model:show="state.show_marital_status"
          destroy-on-close
          round
          position="bottom"
        >
          <van-picker
            title="婚姻状况"
            :columns="state.marital_status"
            @confirm="
              (item) => {
                state.model.marital_status = item.selectedValues[0];
                state.show_marital_status = false;
              }
            "
            @cancel="
              () => {
                state.show_marital_status = false;
              }
            "
          />
        </van-popup>
        <van-cell
          title="生育状况"
          title-class="self-title"
          is-link
          :value="state.model.fertility_status"
          @click="state.show_fertility_status = true"
        />
        <van-popup
          v-model:show="state.show_fertility_status"
          destroy-on-close
          round
          position="bottom"
        >
          <van-picker
            title="生育状况"
            :columns="state.fertility_status"
            @confirm="
              (item) => {
                state.model.fertility_status = item.selectedValues[0];
                state.show_fertility_status = false;
              }
            "
            @cancel="
              () => {
                state.show_fertility_status = false;
              }
            "
          />
        </van-popup>
        <van-cell
          title="政治面貌"
          title-class="self-title"
          is-link
          :value="state.model.political_status"
          @click="state.show_political_status = true"
        />
        <van-popup
          v-model:show="state.show_political_status"
          destroy-on-close
          round
          position="bottom"
        >
          <van-picker
            title="政治面貌"
            :columns="state.political_status"
            @confirm="
              (item) => {
                state.model.political_status = item.selectedValues[0];
                state.show_political_status = false;
              }
            "
            @cancel="
              () => {
                state.show_political_status = false;
              }
            "
          />
        </van-popup>
        <van-field
          v-model="state.model.native_place"
          label="籍贯"
          input-align="right"
          label-class="self-title"
        />
        <van-cell
          title="户籍城市"
          title-class="self-title"
          is-link
          :value="
            (state.model.household_province || '') +
            (state.model.household_city || '') +
            (state.model.household_district || '')
          "
          @click="state.show_household = true"
        />
        <van-popup
          v-model:show="state.show_household"
          destroy-on-close
          round
          position="bottom"
        >
          <van-picker
            v-model="state.household"
            title="户籍城市"
            :columns="state.area_tree"
            :columns-field-names="{
              text: 'name',
              value: 'name',
            }"
            @confirm="
              (item) => {
                state.model.household_province = item.selectedOptions[0]?.name;
                state.model.household_city = item.selectedOptions[1]?.name;
                state.model.household_district = item.selectedOptions[2]?.name;
                state.show_household = false;
              }
            "
            @cancel="
              () => {
                state.show_household = false;
              }
            "
          />
        </van-popup>
        <van-field
          v-model="state.model.household_address"
          type="textarea"
          label="户籍详细地址"
          input-align="right"
          rows="1"
          autosize
          label-class="self-title"
          placeholder="请填写户籍详细地址"
        />
        <van-cell
          title="户口性质"
          title-class="self-title"
          is-link
          :value="state.model.household_type"
          @click="state.show_household_type = true"
        />
        <van-popup
          v-model:show="state.show_household_type"
          destroy-on-close
          round
          position="bottom"
        >
          <van-picker
            title="户口性质"
            :columns="state.household_type"
            @confirm="
              (item) => {
                state.model.household_type = item.selectedValues[0];
                state.show_household_type = false;
              }
            "
            @cancel="
              () => {
                state.show_household_type = false;
              }
            "
          />
        </van-popup>
        <van-cell
          title="参加工作日期"
          is-link
          title-class="self-title"
          :value="state.model.work_date"
          @click="state.show_work_date = true"
        />
        <van-calendar
          v-model:show="state.show_work_date"
          switch-mode="year-month-date"
          :max-date="new Date()"
          @confirm="
            (value) => {
              state.model.work_date = $dayjs(value).format('YYYY-MM-DD');
              state.show_work_date = false;
            }
          "
        />
        <van-cell
          title="学历"
          title-class="self-title"
          is-link
          :value="state.model.education"
          @click="state.show_education = true"
        />
        <van-popup
          v-model:show="state.show_education"
          destroy-on-close
          round
          position="bottom"
        >
          <van-picker
            title="学历"
            :columns="state.education"
            @confirm="
              (item) => {
                state.model.education = item.selectedValues[0];
                state.show_education = false;
              }
            "
            @cancel="
              () => {
                state.show_education = false;
              }
            "
          />
        </van-popup>
        <div
          style="
            background-color: #f6f6f6;
            display: flex;
            flex-direction: column;
            height: 10px;
          "
        ></div>
        <div
          style="
            background-color: #fff;
            padding: 10px;
            display: flex;
            flex-direction: column;
          "
        >
          <ul style="display: flex; align-items: center">
            <li
              style="width: 3px; background-color: #1e90ff; height: 15px"
            ></li>
            <text style="font-weight: 600; font-size: 13px; margin-left: 5px">
              入职信息
            </text>
          </ul>
          <template v-for="(item, index) in state.applicationUnit" :key="item">
            <div
              :style="{
                marginTop: index != 0 ? '10px' : '',
                borderTop: index != 0 ? '1px solid #e2e2e2' : '',
              }"
            >
              <van-cell
                title="入职单位"
                :value="item.customer_name"
                title-class="self-title"
                style="color: #f00"
              >
                <template #default>
                  <text :style="{ color: state.color[index % 3] }">{{
                    item.customer_name
                  }}</text>
                </template>
              </van-cell>
              <van-cell
                title="入职日期"
                :value="item.entry_time"
                title-class="self-title"
              />
              <van-cell
                title="离职日期"
                :value="item.resignation_time || '-'"
                title-class="self-title"
              />
              <van-cell
                title="收款户名"
                :value="item.bank_account_name"
                title-class="self-title"
              />
              <van-cell
                title="开户行"
                :value="item.opening_bank"
                title-class="self-title"
              />
              <van-cell
                title="帐号"
                :value="item.bank_account"
                title-class="self-title"
              />
            </div>
          </template>
        </div>
      </van-cell-group>
      <div v-if="state.active == 2">
        <div style="background-color: #fff; border-radius: 7px; padding: 10px">
          <ul
            style="
              display: flex;
              align-items: center;
              border-left: 4px solid #1e90ff;
              padding-left: 10px;
              line-height: 20px;
            "
          >
            <li style="font-weight: 600; font-size: 13px; flex: 1">证件正面</li>
            <van-uploader :after-read="(file) => onUploaderAfter(file, 0)">
              <van-button
                plain
                type="primary"
                icon="plus"
                style="border: 0; height: 20px; font-size: 13px"
              >
                上传图片
              </van-button>
            </van-uploader>
          </ul>
          <van-image
            style="width: 100%; height: 50vw; margin-top: 10px"
            @click="onShowImageView(state.files[0])"
            :src="state.files[0]"
            fit="contain"
          />
        </div>
        <div
          style="
            background-color: #fff;
            border-radius: 7px;
            padding: 10px;
            margin-top: 10px;
          "
        >
          <ul
            style="
              display: flex;
              align-items: center;
              border-left: 4px solid #1e90ff;
              padding-left: 10px;
              line-height: 20px;
            "
          >
            <li style="font-weight: 600; font-size: 13px; flex: 1">证件反面</li>
            <van-uploader :after-read="(file) => onUploaderAfter(file, 1)">
              <van-button
                plain
                type="primary"
                icon="plus"
                style="border: 0; height: 20px; font-size: 13px"
              >
                上传图片
              </van-button>
            </van-uploader>
          </ul>
          <van-image
            style="width: 100%; height: 50vw; margin-top: 10px"
            @click="onShowImageView(state.files[1])"
            :src="state.files[1]"
            fit="contain"
          />
        </div>
        <div
          style="
            background-color: #fff;
            border-radius: 7px;
            padding: 10px;
            margin-top: 10px;
          "
        >
          <ul
            style="
              display: flex;
              align-items: center;
              border-left: 4px solid #1e90ff;
              padding-left: 10px;
              line-height: 20px;
            "
          >
            <li style="font-weight: 600; font-size: 13px; flex: 1">毕业证书</li>
            <van-uploader :after-read="(file) => onUploaderAfter(file, 2)">
              <van-button
                plain
                type="primary"
                icon="plus"
                style="border: 0; height: 20px; font-size: 13px"
              >
                上传图片
              </van-button>
            </van-uploader>
          </ul>
          <van-image
            style="width: 100%; height: 50vw; margin-top: 10px"
            @click="onShowImageView(state.files[2])"
            :src="state.files[2]"
            fit="contain"
          />
        </div>
        <div
          style="
            background-color: #fff;
            border-radius: 7px;
            padding: 10px;
            margin-top: 10px;
          "
        >
          <ul
            style="
              display: flex;
              align-items: center;
              border-left: 4px solid #1e90ff;
              padding-left: 10px;
              line-height: 20px;
            "
          >
            <li style="font-weight: 600; font-size: 13px; flex: 1">证件照</li>
            <van-uploader :after-read="(file) => onUploaderAfter(file, 3)">
              <van-button
                plain
                type="primary"
                icon="plus"
                style="border: 0; height: 20px; font-size: 13px"
              >
                上传图片
              </van-button>
            </van-uploader>
          </ul>
          <van-image
            style="width: 100%; height: 50vw; margin-top: 10px"
            @click="onShowImageView(state.files[3])"
            :src="state.files[3]"
            fit="contain"
          />
        </div>
      </div>
    </div>
    <van-button type="primary" style="margin: 10px" @click="onSubmit">
      保存修改
    </van-button>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  self_info,
  self_data_select,
  self_area_tree,
  attachment_upload,
  self_save,
} from "@/http/api";
import { showImagePreview, showConfirmDialog, showNotify } from "vant";
export default {
  setup() {
    const state = reactive({
      active: 1,
      model: {},
      files: [],
      color: ["#1e90ff", "#ffa500", "#080"],
      household: [],
    });
    onMounted(() => {
      self_data_select().then((res) => {
        if (res.status == 200) {
          const {
            household_type,
            peoples,
            marital_status,
            fertility_status,
            political_status,
            education,
          } = res.data.data;
          state.household_type = household_type?.map((m) => {
            return { text: m, value: m };
          });
          state.peoples = peoples?.map((m) => {
            return { text: m, value: m };
          });
          state.marital_status = marital_status?.map((m) => {
            return { text: m, value: m };
          });
          state.fertility_status = fertility_status?.map((m) => {
            return { text: m, value: m };
          });
          state.political_status = political_status?.map((m) => {
            return { text: m, value: m };
          });
          state.education = education?.map((m) => {
            return { text: m, value: m };
          });
        }
      });

      self_area_tree().then((res) => {
        if (res.status == 200) state.area_tree = res.data.data?.list;
      });

      onLoad();
    });

    const onLoad = () => {
      self_info().then((res) => {
        if (res.status == 200) {
          const { applicationUnit, employee, info } = res.data.data;
          state.applicationUnit = applicationUnit;
          state.model = {
            name: employee.name,
            sex: employee.sex,
            phone: employee.phone,
            idtype: employee.idtype,
            idcard: employee.idcard,
            id_start: info.id_start,
            id_end: info.id_end,
            marital_status: info.marital_status,
            fertility_status: info.fertility_status,
            nation: info.nation,
            political_status: info.political_status,
            native_place: info.native_place,
            household_type: info.household_type,
            household_province: info.household_province,
            household_city: info.household_city,
            household_district: info.household_district,
            household_address: info.household_address,
            work_date: info.work_date,
            education: info.education,
            id_front: info.attachment?.id_front?.id,
            id_back: info.attachment?.id_back?.id,
            graduation_certificate: info.attachment?.graduation_certificate?.id,
            id_photo: info.attachment?.id_photo?.id,
          };

          state.household = [
            info.household_province,
            info.household_city,
            info.household_district,
          ];

          state.files = [
            info.attachment?.id_front?.file_url,
            info.attachment?.id_back?.file_url,
            info.attachment?.graduation_certificate?.file_url,
            info.attachment?.id_photo?.file_url,
          ];
        }
      });
    };

    const onUploaderAfter = (file, type) => {
      const formData = new FormData();
      formData.append("file[]", file.file);

      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          const resData = res.data.data;
          state.files[type] = resData[0].file_url;

          switch (type) {
            case 0:
              state.model.id_front = resData[0].id;
              break;
            case 1:
              state.model.id_back = resData[0].id;
              break;
            case 2:
              state.model.graduation_certificate = resData[0].id;
              break;
            case 3:
              state.model.id_photo = resData[0].id;
              break;
            default:
              break;
          }
        }
      });
    };

    const base64ToFile = (base64Data) => {
      const filename = "1.jpg";
      // 将base64的数据部分提取出来
      const parts = base64Data.split(";base64,");
      const contentType = parts[0].split(":")[1];
      const raw = window.atob(parts[1]);

      // 将原始数据转换为Uint8Array
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      // 使用Blob对象创建File对象
      const blob = new Blob([uInt8Array], { type: contentType });
      blob.lastModifiedDate = new Date();
      blob.name = filename;

      return new File([blob], filename, { type: contentType });
    };

    const onShowImageView = (src) => {
      if (src) showImagePreview([src]);
    };

    const onSubmit = () => {
      showConfirmDialog({
        title: "签收确认",
        message: `您确定更新档案信息？`,
        allowHtml: true,
        confirmButtonText: "确认更新",
      }).then(() => {
        self_save(state.model).then((res) => {
          if (res.status == 200) {
            showNotify({ type: "success", message: res.data.msg });
            onLoad();
          }
        });
      });
    };
    return { state, onUploaderAfter, base64ToFile, onShowImageView, onSubmit };
  },
};
</script>
<style lang="less">
.self-title {
  color: #a2a2a2;
}
</style>
